module.exports = function(app) {
	'use strict';

	app.directive('calendarButton', function() {
		return {

			restrict: "A",
			replace: false,

			scope: {
				calBinding: '=',
				calOptions: '='
			},

			template:	'<button aria-label="calendarButton" data-ng-click="showCalendar = !showCalendar" type="button"><span class="hmhs-icon x2 calendar"></span></button>' +
						'<div data-ng-show="showCalendar"' +
							'data-calendar="calBinding"' +
							'data-on-double-click="showCalendar = false"' +
							'data-dateMax="calOptions.dateMax"' +
							'data-dateMin="calOptions.dateMin"' +
							'data-stayLessThan="calOptions.stayLessThan"' +
							'data-stayMoreThan="calOptions.stayMoreThan"' +
							'data-init-empty="calOptions.initEmpty">' +
						'</div>',


			link: function ($scope, element, attrs) {
				$scope.showCalendar = false;

				var handler = function(evt) {
					if (!$(evt.target).closest(element).length) {
						$scope.showCalendar = false;
					}
				};

				$(document).on('click', handler);
				$scope.$on('$destroy', function () {
					$(document).off('click', handler);
				});
			}
		};
	});
};
